import React from 'react';
import './App.css';
import Categories from "./components/Categories/Categories";

function App() {
    return (
        <div className="App">
            <Categories/>
        </div>
    );
}

export default App;
